import React, {useState,useEffect,useRef} from 'react'
import {
	addFoodToMeal,
	addItemToEvent,
	getEventDetails,
	replaceEventItem,
	swapNutritionFood
} from '../../../state/events'
import useWindowSize from '../../../hooks/useWindowSize'
import {useResource} from '../../../hooks/resources'
import {update as updateResourceLibrary} from '../slice'
import {useEvent} from '../../../hooks/events'
import ListOptions from '../../foodList/ListOptions/ListOptions'
import {useDebounceCallback} from '@react-hook/debounce'
import {
	createFood,
	getFoodLibrary,
	selectAllFoods,
	searchFoods,
	getFoods,
	selectLibrary
} from '../../../state/foodLibrary'
import {
	addFoodToRecipe,
	swapFood
} from '../../recipes/recipesSlice'
import { useInView } from 'react-intersection-observer'
import {useSelector,useDispatch} from 'react-redux'
import {useFoodLibrary} from '../../foodList/hooks'
import Form from 'react-bootstrap/Form'
import Select from "react-select"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import useCurrentUser from '../../../hooks/useCurrentUser'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import PortionUnitSelect from '../../PortionUnitSelect/PortionUnitSelect'
import FoodPortionSelect from '../../FoodPortionSelect/FoodPortionSelect'

import BarcodeScanner from '../../BarcodeScanner/BarcodeScanner'

const Creator = ({show,handleClose})=>{
	//here we grab the library state that is part of the event editor
	const {
		tgtResourceId,
		tgtResourceType,
		replace,
		insertPosition
	} = useSelector(state=>state.resourceLibrary)
	const resource = useResource(tgtResourceType,tgtResourceId)
	//get replace state. This holds the id and type of the exercise
	//getting replaced. The id will be falsey if not replacing
	const replacing = Boolean(replace.id)

	/* --- hooks --- */

	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch();
	/* --- local state --- */
	const [status,setStatus] = useState('idle')
	const [name,setName] = useState('')
	const [calories,setCalories] = useState('')
	const [protein,setProtein] = useState('')
	const [carbs,setCarbs] = useState('')
	const [fat,setFat] = useState('')
	const [sodium,setSodium] = useState('')
	const [fiber,setFiber] = useState('')
	const [portionUnitId,setPortionUnitId] = useState(0)
	const [portionSize,setPortionSize] = useState(0)
	const [portionDescription,setPortionDescription] = useState('')

	console.log(tgtResourceType,replace)

	const hasRequiredFields = (
		Boolean(name) &&
		Boolean(portionUnitId) &&
		Boolean(portionSize)
	)

	/* --- handlers --- */

	/**
	 * Handles two cases: 
	 * - adding new food
	 * - replacing existing food with another
	 * For two three tgt resource types:
	 * - nutrition
	 * - meal
	 * - recipe
	 */
	const handleInsert = (food)=>{
		if (tgtResourceType==='nutrition') {
			if (replacing) {
				dispatch(replaceEventItem({
					current_item_id:replace.id,
					event_type:'nutrition',
					item_db_id:food.food_db_id,
					resource_type:food.resource_type
				}))
				.then(()=>{
					//clear out replace
					dispatch(updateResourceLibrary({replace:{}}))
				})
			}
			else{
				const payload = {
					item_db_id:food.food_db_id,
					name:food.food_db_name,
					event_type:'nutrition',
					event_id:tgtResourceId,
					type:'food'
				}

				if (Boolean(insertPosition)) {
					payload.routine_order = insertPosition
				} else {
					payload.routine_order = resource.food.length + 1
				}
				dispatch(addItemToEvent(payload))
				dispatch(updateResourceLibrary({
					insertPosition:(
						Boolean(insertPosition)
						? insertPosition + 1
						: resource.food.length + 2
					)
				}))
			}
		}
		else if (tgtResourceType==='recipe') {
			if (replacing) {
				dispatch(swapFood({
					food_db_name:food.food_db_name,
					recipe_id:tgtResourceId,
					update:{
						food_db_id:food.food_db_id
					},
					food,
					id:replace.id
				}))
			} else {
				dispatch(addFoodToRecipe({
					food_db_name:food.food_db_name,
					recipe_id:tgtResourceId,
					food_db_id:food.food_db_id,
					food_source:food.food_source
				}))
			}//end else
		}//end if type = recipe
		else if (tgtResourceType==='meal') {
			if (replacing) {
				statusDispatch(swapNutritionFood({
					food_id:replace.id,
					food_db_id:food.food_db_id,
				}), "food", "replace").then(()=>{
					//clear out replace
					dispatch(updateResourceLibrary({replace:{}}))
				})
			} else {
				dispatch(addFoodToMeal({
					food_db_name:food.food_db_name,
					meal_id:tgtResourceId,
					food_db_id:food.food_db_id,
					routine_order:insertPosition
				}))
				dispatch(updateResourceLibrary({
					insertPosition:insertPosition+1
				}))
			}//end else
		}//end if type = recipe
	}

	const handleCreate = ()=>{
		setStatus('pending')
		dispatch(createFood(
			{
				food_db_name:name,
				protein,
				carbs,
				calories,
				fat,
				sodium,
				fiber,
				portion_unit_id:portionUnitId,
				portion_size:portionSize,
				portion_description:portionDescription
			}
		)).then(({payload})=>{
			setStatus('idle')
			//insert into workout
			handleInsert(payload.data.food)
			//close modal
			handleClose()
			//clear out data
			setName('')
			setProtein('')
			setCalories('')
			setCarbs('')
			setFat('')
			setSodium('')
			setFiber('')
		})
	}

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<strong>Create New food</strong>
			</Modal.Header>
			<Modal.Body>
				<label>Name*</label>
				<Form.Control 
					onChange={ e => { setName(e.target.value) } }
					placeholder="New food name" 
					className="mb-2"
				/>
				<label>Portion Unit (e.g scoop)*</label>
				<PortionUnitSelect
					portionUnit={portionUnitId}
					onChange={selected=>{
						setPortionUnitId(selected.value)
					}}
				/>
				<label>Portion Size*</label>
				<Form.Control 
					onChange={ e => { setPortionSize(e.target.value) } }
					placeholder="portion size" 
					className="mb-2"
				/>
				<label>Portion Description</label>
				<Form.Control 
					as="textarea"
					onChange={ e => { setPortionDescription(e.target.value) } }
					placeholder="Example: large slice" 
					className="mb-2"
				/>
				<label>Calories</label>
				<Form.Control 
					onChange={ e => { setCalories(e.target.value) } }
					placeholder="calories" 
					className="mb-2"
				/>
				<label>Protein</label>
				<Form.Control 
					onChange={ e => { setProtein(e.target.value) } }
					placeholder="protein" 
					className="mb-2"
				/>
				<label>Carbs</label>
				<Form.Control 
					onChange={ e => { setCarbs(e.target.value) } }
					placeholder="carbs" 
					className="mb-2"
				/>
				<label>Fat</label>
				<Form.Control 
					onChange={ e => { setFat(e.target.value) } }
					placeholder="fat" 
					className="mb-2"
				/>
				<label>Sodium</label>
				<Form.Control 
					onChange={ e => { setSodium(e.target.value) } }
					placeholder="sodium" 
					className="mb-2"
				/>
				<label>Fiber</label>
				<Form.Control 
					onChange={ e => { setFiber(e.target.value) } }
					placeholder="fiber" 
					className="mb-2"
				/>
				<Button 
					disabled={status==='pending' || !hasRequiredFields}
					onClick={handleCreate}
					variant="outline-primary"
					block
				>
					{
						status === 'pending' ?
						<Spinner size="sm" animation="border"/>:
						'Create & Add Food'
					}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

const Food = ({food,handleInsert,replacing})=>{
	const [qty,setQty] = useState(1)
	//foood and portion data all have macro data defined on them
	//if no portion data is defined default to using the food 
	const [portion,setPortion] = useState(food.portions[0] || food)
	const [status,setStatus] = useState('idle')
	return (
		<div 
			key={food.food_db_id} 
			className="d-flex align-items-center p-1" 
			style={{borderBottom:'1px solid #ccc'}}
		>
			<OverlayTrigger overlay={
				<Tooltip>{replacing?'Replace Selected Food':'Add to Routine'}</Tooltip>
			}>
				<Button 
					disabled={status==='pending'}
					className="mr-2"
					variant="outline-success"
					size="sm"
					onClick={()=>{
						setStatus('pending')
						handleInsert(food,qty,portion.id||0).finally(()=>{
							setStatus('idle')
						})
						setQty(1)
					}}
				>
					{status==='idle'&&<i className={
						replacing
						? "fas fa-exchange-alt"
						: "fas fa-plus"
					}/>}
					{status==='pending'&&
						<Spinner animation="border" size="sm"/>
					}
				</Button>
			</OverlayTrigger>
			<Form.Control 
				onChange={ e => {
					setQty(e.target.value)
				}}
				className="mr-1"
				style={{width:'40px'}}
				placeholder="qty"
				value={qty}
				size="sm"
			/>
			<div className="w-100">
				<div className="d-flex flex-wrap">
					<span className="d-block">
						{food.food_db_name}{Boolean(food.brand_owner)&&` (${food.brand_owner})`}
					</span>
					<span className="ml-auto">
						<FoodPortionSelect
							onChange={portion=>{
								setPortion(portion)
							}}
							portions={food.portions}
						/>
					</span>
				</div>
				{Boolean(food.usage_count)&&
					<small className="d-block text-muted">
						Recently used {food.usage_count} times
					</small>
				}
			</div>
		</div>
	)
}

const Foods = ({typeSelector})=>{
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch();
	const [windowWidth,windowHeight] = useWindowSize()
	//here we grab the library state that is part of the event editor
	const {tgtResourceId,tgtResourceType,insertPosition} = useSelector(
		state => state.resourceLibrary
	)
	const resource = useResource(tgtResourceType,tgtResourceId)
	//this only returns status and list of foods
	const foods = useSelector(selectAllFoods)
	const {tgtUser:currentTgtUser} = useSelector(selectLibrary)
	const [listTypes, setListTypes] = useState(
		Boolean(localStorage.getItem('listTypes'))
		? JSON.parse(localStorage.getItem('listTypes'))
		: ["all_foods"]
	)
	const foodBlockSize = 100
	//get replace state. This holds the id and type of the exercise
	//getting replaced. The id will be falsey if not replacing
	const replace = useSelector(state=>state.resourceLibrary.replace)
	const replacing = Boolean(replace.id)

	const [query,setQuery] = useState('')
	const [showCreator,setShowCreator] = useState(false)

	//add a max count to prevent huge food lists
	//from slowing downt he UI
	const [maxFoodCount, setMaxFoodCount] = useState(100)

	// const maxFoodCount = 100
	const filteredFoods = foods.filter( food => (
		food.food_db_name.toLowerCase().indexOf(query.toLowerCase().trim()) > -1
	))

	const displayFoods = filteredFoods.slice(0,maxFoodCount)

	const handleScroll = (e) => {
		if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
			setMaxFoodCount(maxFoodCount+100)
		}
	}

	const expandList = () => {
		setMaxFoodCount(maxFoodCount+300)
	}

	/**
	 * Handles two cases: 
	 * 1) adding new exercise 
	 * 2) replacing existing exercise with another
	 */
	const handleInsert = (food,qty,portionId)=>{
		if (tgtResourceType==='nutrition') {
			if (replacing) {
				return statusDispatch(replaceEventItem({
					current_item_id:replace.id,
					event_type:'nutrition',
					item_db_id:food.food_db_id,
					food_db_portion_id:portionId,
					qty,
					food_source:food.food_source
				}), "food", "replace").then(()=>{
					//clear out replace
					dispatch(updateResourceLibrary({replace:{}}))
				})
			} else {
				const payload = {
					item_db_id:food.food_db_id,
					name:food.food_db_name,
					event_type:'nutrition',
					event_id:tgtResourceId,
					food_db_portion_id:portionId,
					qty,
					food_source:food.food_source
				}

				if (Boolean(insertPosition)) {
					payload.routine_order = insertPosition
				} else {
					payload.routine_order = resource.food.length + 1
				}

				
				dispatch(updateResourceLibrary({
					insertPosition:(
						Boolean(insertPosition)
						? insertPosition + 1
						: resource.food.length + 2
					)
				}))
				return statusDispatch(addItemToEvent(payload), "food", "add")
			}
		}//end if type is nutrition
		else if (tgtResourceType==='recipe') {
			if (replacing) {
				return dispatch(swapFood({
					recipe_id:tgtResourceId,
					update:{
						food_db_id:food.food_db_id,
						food_db_portion_id:portionId,
					},
					food,
					qty,
					id:replace.id
				}))
			} else {
				return dispatch(addFoodToRecipe({
					quantity:qty,
					food_db_name:food.food_db_name,
					recipe_id:tgtResourceId,
					food_db_id:food.food_db_id,
					food_db_portion_id:portionId,
					food_source:food.food_source
				}))
			}//end else
		}//end if type = recipe
		else if (tgtResourceType==='meal') {
			if (replacing) {
				return statusDispatch(swapNutritionFood({
					food_id:replace.id,
					food_db_id:food.food_db_id,
					food_db_portion_id:portionId,
					food_source:food.food_source
				}), "food", "replace").then(()=>{
					//clear out replace
					dispatch(updateResourceLibrary({replace:{}}))
				})
			} else {
				console.log(food)
				dispatch(updateResourceLibrary({
					insertPosition:insertPosition+1
				}))
				return dispatch(addFoodToMeal({
					qty,
					food_db_name:food.food_db_name,
					meal_id:tgtResourceId,
					food_db_id:food.food_db_id,
					routine_order:insertPosition,
					food_db_portion_id:portionId,
					food_source:food.food_source
				}))
			}//end else
		}//end if type = recipe
		else if (tgtResourceType==='meal_food'){
			//if replacing a meal food
			return statusDispatch(swapNutritionFood({
				food_id:replace.id,
				food_db_id:food.food_db_id,
				food_db_portion_id:portionId,
				food_source:food.food_source
			}), "food", "replace").then(()=>{
				//clear out replace
				dispatch(updateResourceLibrary({replace:{}}))
			})
		}
	}//end handleInsert

	const [status,setStatus] = useState('idle')
	const dispatchSearch = () => {
		if (!query) return 
		setStatus('pending')
		if (pendingRequestRef.current&&pendingRequestRef.current.abort) {
			pendingRequestRef.current.abort()
		}
		const promise = dispatch(
			searchFoods({query,list_types:listTypes,clearFoods:true})
		).then(()=>{
			setStatus('idle')
		})
		pendingRequestRef.current = promise
	}

	const debouncedSearch = useDebounceCallback(dispatchSearch,400)

	const handleSearch = query => {
		setQuery(query)
		if(!Boolean(query)){
			setStatus('idle')
		}
		else{
			setStatus('typing')
			debouncedSearch(query)
		}
	}

	const { ref:scrollRef, inView } = useInView({
		/* Optional options */
		threshold: 0,
	})

	const pendingRequestRef = useRef()

	useEffect(()=>{
		if (listTypes.length === 0) return
		if (!Boolean(query)) return
		if (
			pendingRequestRef.current &&
			pendingRequestRef.current.abort
		) {
			pendingRequestRef.current.abort()
		}
		setStatus('pending')
		const params = new URLSearchParams(window.location.search)
		const clientId = params.get('client')
		const payload = {
			list_types:listTypes,
			query:query,
			limit:foodBlockSize,
			offset:0,
			clearFoods:true
		}
		
		if(Boolean(clientId)) payload.tgt_user_id_number = clientId

		const promise = dispatch(searchFoods(payload)).finally(()=>{
			setStatus('idle')
		})

		pendingRequestRef.current = promise
	},[listTypes])

	return (
		<>
			<div 
				style={{
					width:'100%',
					height:'100%',
				}}
				className="d-flex align-items-stretch flex-column flex-md-row"
			>
				<div 
					className="p-2" 
					style={{
						width:windowWidth > 767 ? '180px' : '100%',
						background:'#e5e7f5',
						flex:'0 0 auto'
					}}
				>
					{typeSelector}
					<Form.Control 
						onChange={e=>{
							handleSearch(e.target.value)
						}}
						placeholder="search"
						value={query}
					/>
					{(!user.isMAXUser)&&
						<ListOptions 
							accountType={user.account_type}
							selected={listTypes}
							onChange={selected=>{
								setListTypes(selected)
							}}
							flow="md-column"
							align="start"
						/>
					}
					{!user.isMAXUser&&
						<a href="https://www.fatsecret.com">
							<img src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_3x.png 3x" border="0"/>
						</a>
					}
					<Button 
						onClick={()=>{ setShowCreator(true) }}
						variant="outline-success" 
						className="mt-2" 
						size="sm" 
						block
					>
						Create New Food
					</Button>
				</div>
				<div 
					style={{
						overflow:'auto',
						height:'100%',
						flex:'1 1 auto'
					}}
					
					onScroll={handleScroll}
				>
					{status==='typing'&&
						<div className="p-2">
							Typing...
						</div>
					}
					{(Boolean(query)&&status==='idle'&&displayFoods.length>0)&&
						displayFoods.map( food => (
							<Food food={food} replacing={replacing} handleInsert={handleInsert}/>
						))
					}
					{(Boolean(query)&&status==='idle'&&displayFoods.length===0)&&
						<div className="p-2">
							No results...
						</div>
					}
					{(!Boolean(query)&&status==='idle')&&
						<div className="p-2">
							Search for foods using the text box to the left...
						</div>
					}
					{(Boolean(query)&&status==='pending')&&
						<div className="d-flex align-items-center justify-content-center p-4">
							<Spinner animation="border" role="status">
								<span className="sr-only">Loading...</span>
							</Spinner>
						</div>
					}
					<div ref={scrollRef}/>
				</div>
			</div>
			<Creator show={showCreator} handleClose={()=>{setShowCreator(false)}}/>
		</>
	)
}

export default Foods